import { calculateBoxSizes as r } from "./algorithms/calculateBoxSize.js";
import { freeze as t } from "./utils/freeze.js";
var s = function() {
  function i(o) {
    var e = r(o);
    this.target = o, this.contentRect = e.contentRect, this.borderBoxSize = t([e.borderBoxSize]), this.contentBoxSize = t([e.contentBoxSize]), this.devicePixelContentBoxSize = t([e.devicePixelContentBoxSize]);
  }
  return i;
}();
export {
  s as ResizeObserverEntry
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/ResizeObserverEntry.js
// module id = 1351
// module chunks = 67